import styled from 'styled-components';

export default Object.freeze({
	Section: styled.section`
      background: cadetblue;
      height: 200px;
	`,
});